import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {AttachmentsService} from 'src/app/services/attachments/attachments.service';
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatListModule} from "@angular/material/list";
import {CommonModule, DatePipe} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {HttpService} from "../../services/http/http.service";
import {SediDialog} from "../sedi-dialog/sedi-dialog.component";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MaterialModule} from "../../app-material.module";

@Component({
  selector: 'details-dialog',
  templateUrl: './details-dialog.component.html',
  styleUrls: ['./details-dialog.component.scss'],
  standalone: true,
  imports: [MatRadioModule, MatDatepickerModule, MatListModule, CommonModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule, MatSlideToggleModule, MaterialModule],
})
export class DetailsDialog implements OnInit {
  onAddClick = new EventEmitter();
  telefono: any;
  fax: any;
  email: any;
  ruolo: any;
  operatore: any;
  listaRuoli: any;
  listaOperatori: any;
  listaComuni: any;
  listaProvince: any;
  comune: any;
  provincia: any;
  listaTipoOperatori: any;
  loading: boolean = false;
  selectData: any;

  constructor(
    public dialogRef: MatDialogRef<DetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public datepipe: DatePipe,
    private attachmentsService: AttachmentsService,
    private api: HttpService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (this.data.isProfilo) {
      this.data.details.tipologia = {
        id: 2
      };
      const descrizione: string = this.data.descrizioneCompetenza;
      if (descrizione) {
        this.data.details.descrizione = descrizione;
      }
    }

    if (this.data.sectionName == 'gestioneUtenze') {
      if (this.data.details.listaRuoli && this.data.details.listaRuoli.length) {
        this.ruolo = this.data.details.listaRuoli[0];
        this.setOperatoreOnInit();
      }
      else{
        this.ruolo = {id:-1,descrizione:"N/A"}
      }
      this.ruoliUtente();
    }

    if (this.data.sectionName == 'gestioneAssemblea' && this.data.type != 'new') {
      this.data.details.dataRiunione = this.data.details.dataRiunione ? new Date(this.data.details.dataRiunione) : new Date();
      this.data.details.dataApprovazione = this.data.details.dataApprovazione ? new Date(this.data.details.dataApprovazione) : new Date();
      this.data.details.dataDecreto = this.data.details.dataDecreto ? new Date(this.data.details.dataDecreto) : new Date();
    }
    if (this.data.sectionName == 'gestioneOperatori') {
      if (!this.data.details.tipoOperatore) {
        this.data.details.tipoOperatore = {};
      }
      this.getProvince();
      if (this.data.type == 'edit') {
        this.getComuni(this.data.details.cmbProvincia.id);
      }

      this.getListaTipoOperatori();
    }
  }

  onFileSelected(event: any) {

    const file: File = event.target.files[0];

    if (file) {
      this.api.uploadDocumentoDecreto(file).subscribe({
        next: (response: any) => {
          this.data.details.idDocumentoDecreto = response.result.valore;
        }
      });
    }


  }

  cantSaveDettaglio() {
    let checkForm;
    if (this.data.sectionName == 'gestioneProfiloProfessionale') {
      checkForm = (!(this.data.details.nomeProfilo &&
        this.data.details.descrizioneArea.id &&
        this.data.details.descrizioneProfilo &&
        this.data.details.elementiContesto &&
        this.data.details.livelloEqf));
    }

    if (this.data.sectionName == 'gestioneCompetenze') {
      let checkArea = this.data.details.tipologia.id !== 1 ? true : this.data.details.tipoArea.id;
      const isCompetenzaBase = this.data.details.tipologia.id === 3;
      const isIndipendente = this.data.details.tipologia.id === 1;
      const isDigitale = this.data.details.tipologia.id === 6;
      const infoCompNotPresent = !this.data.details.informazioniCompetenza;
      const sottoCategoriaNotPresent = !this.data.details.idTCategoriaBase;
      const digitalSubCategoryNotPresent = !this.data.details.idTCategoriaDigitale;
      checkForm = (!(this.data.details.tipologia.id &&
          checkArea &&
          this.data.details.descrizione &&
          this.data.details.eqfCompetenza)
        || (isCompetenzaBase && sottoCategoriaNotPresent) || (isIndipendente && infoCompNotPresent) || (isDigitale && digitalSubCategoryNotPresent)
      );
    }

    if (this.data.sectionName == 'gestioneUtenze') {
      checkForm = (!(this.data.details.codiceFiscale && this.data.details.nomeUtente &&
        this.data.details.cognomeUtente &&
        this.data.details.listaRuoli && this.data.details.listaRuoli.length && (this.ruolo.id == 10 ? this.operatore : true))); // id 10 = Proponente
    }

    if (this.data.sectionName == 'gestioneOperatori') {
      checkForm = (!(this.data.details.id && this.data.details.descrizione &&
        this.data.details.cmbProvincia && this.data.details.cmbProvincia.id &&
        this.data.details.cmbComune != undefined && this.data.details.cmbComune && this.data.details.cmbComune.id &&
        this.data.details.flagAttivo && this.data.details.listaSedi && this.data.details.listaSedi.length > 0));
    }

    if (this.data.sectionName == 'gestioneAssemblea') {
      checkForm = !(this.data.details.dataRiunione && this.data.details.dataApprovazione && this.data.details.descrizione);
    }

    return checkForm
  }


  getProvince(): void {
    this.api.getProvince().subscribe({
      next: (response: any) => {

        this.listaProvince = response.result;
      }
    })
  }

  getComuni(id: any): void {
    this.api.getComuni(id).subscribe({
      next: (response: any) => {

        this.listaComuni = response.result;
      }
    })
  }

  getListaTipoOperatori(): void {
    this.api.ricercaListaTipoOperatori().subscribe({
      next: (response: any) => {
        this.listaTipoOperatori = response.result;
      }
    })
  }

  ruoliUtente() {
    this.api.caricaRuoliUtenti().subscribe({
      next: (response: any) => {
        this.listaRuoli = response.result;
      }
    })
  }

  getOperatore(selectedRuoloId: any) {
    this.data.details.listaRuoli = this.listaRuoli.filter((r: any) => r.id === selectedRuoloId);

    this.data.details.operatore = null;

    this.api.getOperatoreByRuolo(selectedRuoloId).subscribe({
      next: (response: any) => {
        this.listaOperatori = response.result;
      },
      error: (err) => {
        console.error('Errore nel recuperare gli operatori:', err);
      }
    });
  }

  setOperatoreOnInit(): void {
    if (this.ruolo.id == 10) { // proponente
      this.api.getOperatoreByRuolo(10).subscribe({
        next: (response: any) => {
          this.listaOperatori = response.result;
          this.operatore = this.listaOperatori.find(
            (o: any) => o.id === this.data.details.operatore.id
          );
        },
        error: (err) => {
          console.error('Errore nel recuperare gli operatori:', err);
        },
      });
    }
  }

  addTel(tel: any) {
    if (!tel) {
      return;
    }

    if (!this.data.details.listaTelefoni) {
      this.data.details.listaTelefoni = [];
    }
    this.data.details.listaTelefoni.push({'descrizione': tel});
  }

  addFax(fax: any) {
    if (!this.data.details.listaFax) {
      this.data.details.listaFax = [];
    }
    this.data.details.listaFax.push({'descrizione': fax});
  }

  addEmail(email: any) {
    if (!this.data.details.listaEmail) {
      this.data.details.listaEmail = [];
    }
    this.data.details.listaEmail.push({'descrizione': email});
  }

  addRuolo(ruolo: any, operatore: any) {
    this.data.details.listaRuoli.push(ruolo);
    this.data.details.operatore = operatore;
  }

  selezionaOperatore(operatore: any) {
    this.data.details.operatore = operatore;
  }

  inserisciOperatore(ruolo: any) {
    let detailsData =
      {
        "id": null,
        "descrizione": null,
        "indirizzo": null,
        "cap": null,
        "flagAttivo": null,
        "comune": null,
        "cmbProvincia": {
          "id": null,
          "descrizione": null,
          "ordinamento": null
        },
        "cmbComune": {
          "id": null,
          "descrizione": null,
          "ordinamento": null
        },
        "listaProvince": [],
        "listaComuni": [],
        "listaSedi": [],
        "bModifica": null,
        "tipoOperatore": {
          "id": null,
          "descrizione": null
        }
      }

    let boxData = {
      "type": "input",
      "label": "Nome operatore",
      "value": "",
      "placeholder": "Nome",
      "cssClass": "half-width"
    };
    const dialogRef = this.dialog.open(DetailsDialog, {
      data: {
        details: detailsData,
        permission: true,
        selectData: boxData,
        sectionName: "gestioneOperatori",
        type: "new"
      },
      height: '95%',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      this.api.saveOperatore(result.details).subscribe({
        next: (response: any) => {
          this.api.getOperatoreByRuolo(ruolo.id).subscribe({
            next: (response: any) => {
              this.listaOperatori = response.result;
            }
          })
        }
      })
    });
  }

  removeTel(i: any) {
    this.data.details.listaTelefoni.splice(i, 1);
  }

  removeFax(i: any) {
    this.data.details.listaFax.splice(i, 1);
  }

  removeEmail(i: any) {
    this.data.details.listaEmail.splice(i, 1);
  }

  removeRuolo(i: any) {
    this.data.details.listaRuoli.splice(i, 1);
  }

  removeSede(i: any) {
    this.data.details.listaSedi.splice(i, 1);
  }


  changeSex(e: any) {
    this.data.details.sesso = e.value;
  }

  changeAttivo(e: any) {
    this.data.details.flagAttivo = e.value;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  downloadDecreto(id: any) {
    let data = {
      valore: id
    }
    this.api.downloadDocumento(data).subscribe(
      (data: any) => {
        let fileName: string = "Decreto.pdf";
        this.api.downloadService(data, fileName);
      }
    )
    // this.attachmentsService.downloadDecreto(data).subscribe({
    //   next: (response: any) => {

    //   }
    // })
  }

  competenzaDetail(event: any) {
    this.onAddClick.emit(event);
  }

  apriSede(event: any) {

    const data = {operatore: this.data.details};
    const dialogRef = this.dialog.open(SediDialog, {
      data,
      height: '95%',
      width: '100%'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.data.details.listaSedi.push(result);
      }
    });
  }

  setFlAttivo() {
    this.data.details.flAttivo = !this.data.details.flAttivo;
  }
}
